import styled from "styled-components";

export const LoadingSpinner = styled.div<{ size?: number, color?: string }>`
  /* change color here */
  color: ${({ color }) => color ? color : '#1c4c5b'};

  &,
  &:after {
    box-sizing: border-box;
  }

  width: ${({ size }) => (size ? `${size}px` : '80px')};
  height: ${({ size }) => (size ? `${size}px` : '80px')};

  &:after {
    content: " ";
    display: block;
    width: ${({ size }) => (size ? `${size * 0.8}px` : '64px')};
    height: ${({ size }) => (size ? `${size * 0.8}px` : '64px')};
    margin: ${({ size }) => (size ? `${size * 0.1}px` : '8px')};
    border-radius: 50%;
    border: ${({ size }) => (size ? `${size * 0.08}px` : '6.4px')} solid currentColor;
    border-color: currentColor transparent currentColor transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  animation: fadeIn 1s ease;
`;